// extracted by mini-css-extract-plugin
module.exports = {"ticketTabStrip":"_2izzXH4kiF6XRU4RDVnEXE"};